import React from "react";
import { Button, useDisclosure } from "@chakra-ui/react";
import { IoAddOutline } from "react-icons/io5";
import { Modal } from "components";
import FormUser from "../form";
import { getValidation, useCreateUser } from "./duck";

interface CreateProps {
  isDisabled: boolean;
  onClick: (() => void) | undefined;
  onSuccess(): Promise<any>;
}

const Create: React.FC<CreateProps> = ({ isDisabled, onClick, onSuccess }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onSubmit = useCreateUser(onClose);

  return (
    <>
      <Button
        isDisabled={isDisabled}
        onClick={onClick || onOpen}
        leftIcon={<IoAddOutline />}
      >
        New User
      </Button>
      {isOpen && (
        <Modal title="Create User" onClose={onClose} isOpen>
          <FormUser
            onSubmit={values => onSubmit(values).then(() => onSuccess())}
            onClose={onClose}
            {...getValidation()}
          />
        </Modal>
      )}
    </>
  );
};

export default Create;
